import { jsx as a } from "react/jsx-runtime";
const h = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentcolor",
        d: "M2 6a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2v4h6V7a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2v10a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2v-4H5v4a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2V7a1 1 0 0 1-1-1M19 11a1 1 0 0 0-1 1 1 1 0 1 1-2 0 3 3 0 0 1 6 0c0 .51-.173.996-.356 1.379-.19.397-.431.77-.656 1.073l-.011.015-1.947 2.534H21a1 1 0 1 1 0 2h-4a1 1 0 0 1-.793-1.61l3.178-4.135c.172-.234.337-.492.454-.738.126-.264.161-.437.161-.518a1 1 0 0 0-1-1"
      }
    )
  }
);
export {
  h as default
};
